<template>
  <div class="add-and-edit">
    <section class="add-and-edit__main">
      <el-form
        ref="formRef"
        :model="form"
        label-width="100px"
        :rules="rules"
      >
        <h5>基本信息</h5>
        <el-form-item
          label="管控任务"
          prop="name"
          :rules="[{ required: true, message: '请输入管控任务' }]"
        >
          <el-input
            v-model="form.name"
            placeholder="请输入管控任务"
            clearable
          />
        </el-form-item>

        <el-form-item label="描  述">
          <el-input
            v-model="form.description"
            placeholder="请输入描述"
            clearable
            type="textarea"
          />
        </el-form-item>
        <el-form-item
          label="任务类型"
          prop="type"
          :rules="[{ required: true, message: '请选择任务类型' }]"
        >
          <el-radio-group v-model="form.taskType">
            <el-radio
              v-for="item in TASK_LIST"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item
          v-if="form.taskType==='REGULAR'"
          label="规则类型"
          prop="type"
          :rules="[{ required: true, message: '请选择规则类型' }]"
        >
          <el-radio-group v-model="form.type">
            <el-radio
              v-for="item in TYPE_LIST"
              :key="item.value"
              :label="item.value"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item
          v-if="form.taskType==='REGULAR'"
          label="任务时间"
          prop="time"
          :rules="[{ required: true, message: '请选择时间范围' }]"
        >
          <el-time-picker
            v-model="form.time"
            is-range
            arrow-control
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            format="HH:mm"
          />
        </el-form-item>
        <el-form-item
          v-if="form.taskType==='REGULAR'"
          label="任务次数"
          prop="executeNum"
          :rules="[{ required: true, message: '请输入任务次数' }]"
        >
          <el-input-number
            v-model="form.executeNum"
            placeholder="请输入次数"
            :min="1"
            :step="1"
            step-strictly
            clearable
          />
        </el-form-item>
        <el-form-item
          v-if="form.taskType==='REGULAR'"
          label="循环机制"
          prop="cyclicType"
          :rules="[{ required: true, message: '请选择循环机制' }]"
        >
          <el-select v-model="form.cyclicType" placeholder="请选择循环机制">
            <el-option
              v-for="item in CYCLIC_TYPE_LIST"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <h5>应用范围</h5>
        <el-form-item
          label="应用人员"
          multiple
        >
          <!-- <el-select
            v-model="form.userArr"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loadingGetUser"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select> -->
          <TransferSelect v-model="form.userArr" class="transfer-select" />
        </el-form-item>
      </el-form>
    </section>
    <div class="add-and-edit__footer">
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit"
      >
        提交
      </el-button>
      <el-button @click="handleClose">
        取消
      </el-button>
    </div>
  </div>
</template>

<script>
import { popRuleManagementUpsert, controlPage } from '@/api/userControl';
import TransferSelect from './TransferSelect.vue';
// eslint-disable-next-line import/named
import { TYPE_LIST, TASK_LIST, CYCLIC_TYPE_LIST } from '../constant';

const initForm = () => ({
  name: '',
  description: '',
  taskType: 'REGULAR',
  type: 'FIXED_TIME',
  time: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 18, 0)],
  startTime: '',
  endTime: '',
  executeNum: 1,
  cyclicType: '',
  users: [],
  userArr: [],
});

const validateWeight = (rule, value, callback) => {
  const reg = /^\d{0,2}$/;
  if (value === '') {
    callback(new Error('请输入执行次数'));
  } else if (!reg.test(value)) {
    callback(new Error('执行次数必须为数字值，且不能大于两位数'));
  } else {
    callback();
  }
};

export default {
  name: 'AddAndEdit',
  components: {
    TransferSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    current: {
      type: Object,
      default: null,
    },

  },
  data() {
    return {
      loading: false,
      form: initForm(),
      TYPE_LIST,
      TASK_LIST,
      CYCLIC_TYPE_LIST,
      options: [],
      loadingGetUser: false,
      rules: {
        executeNum: [{ validator: validateWeight, trigger: 'blur' }],
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      if (this.mode === 'ADD') return '新增规则';
      return '编辑规则';
    },
  },
  created() {
    if (this.current) {
      Object.keys(this.form).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.current, key)) {
          this.form[key] = this.current[key];
        }
      });
      this.form.userArr = this.current.users.map((item) => `${item.bizId}||${item.bizName}||${item.bizType}||${item.companyId || ''}||${item.companyName || ''}`);
      this.options = this.current.users.map((item) => ({ label: item.bizName, value: `${item.bizId}||${item.bizName}||${item.bizType}||${item.companyId || ''}||${item.companyName || ''}` }));
      this.form.time = [new Date(2016, 9, 10, this.changeTime(this.current.startTime, 0), this.changeTime(this.current.startTime, 1)), new Date(2016, 9, 10, this.changeTime(this.current.endTime, 0), this.changeTime(this.current.endTime, 1))];
    } else {
      this.form = initForm();
    }
    this.$nextTick(() => {
      this.$refs.formRef.clearValidate();
    });
  },
  methods: {
    changeTime(time, key) {
      const arr = time.split(':');
      // eslint-disable-next-line radix
      const num = parseInt(arr[key]);
      return num;
    },
    async remoteMethod(query) {
      if (query !== '') {
        this.options = [];
        this.loadingGetUser = true;
        const params = {
          page: 1,
          size: 50,
        };
        const data = {
          onlyNeedFaceControlUser: true,
          unifyNameLike: query,
        };
        try {
          const result = await controlPage(data, params);
          this.options = result.records;
          this.options = result.records.map((item) => ({
            label: item.unifyName, value: `${item.unifyId}||${item.unifyName}||UNIFY_USER||${item.companyId || ''}||${item.companyName || ''}`,
          }));
        } finally {
          this.loadingGetUser = false;
        }
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        try {
          this.loading = true;
          this.form.startTime = new Date(this.form.time[0]).getTime();
          this.form.endTime = new Date(this.form.time[1]).getTime();
          this.form.users = this.form.userArr.map((item) => {
            const arr = item.split('||');
            return {
              bizId: arr[0], bizName: arr[1], bizType: arr[2], companyId: arr[3], companyName: arr[4],
            };
          });
          if (this.form.taskType !== 'REGULAR') {
            this.form.cyclicType = 'ONE_TIME';
            this.form.startTime = '';
            this.form.endTime = '';
          }
          const data = {
            ...this.form,
            id: this.current?.id,
          };
          await popRuleManagementUpsert(data);
          this.$message.success('保存成功');
          this.handleClose();
        } finally {
          this.loading = false;
        }
      } catch (err) {
        const error = err[Object.keys(err).shift()].shift();
        this.$message.warning(error.message);
      }
    },
    handleClose() {
      this.$emit('close', 'ok');
    },
  },
};
</script>

<style lang="scss" scoped>

.add-and-edit {
  width: 100%;
  height: 100%;

  &__main {
    width: 100%;
    height: calc(100% - 50px);
    overflow: auto;
  }

  &__footer {
    width: 100%;
    height: 34px;
    margin-top: 16px;
    text-align: right;
  }
}
h5{
  margin-left: 30px;
  border-left: 3px solid #1e3cbb;
  line-height: 13px;
  padding-left: 5px;
  font-size: 13px;
  margin-bottom: 15px;
  color: #1e3cbb;
}
.line{
  margin: 20px 0 30px 30px;
  border-bottom: 1px solid #eee;
}
.dialog-footer{
  display: flex;
  text-align: right;
}
.el-select, .el-input, .el-textarea, .el-date-editor {
  width:400px;
}
.transfer-select{
  :deep(.el-transfer-panel){
    width: 340px;
  }
  :deep(.el-transfer__buttons){
    padding: 0 25px;
    .el-button {
      display: block !important;
      margin-left: 0;
    }
  }
}
</style>
